import React, { createContext, useState, useContext } from 'react';

const SortContext = createContext();

export const SortProvider = ({ children }) => {
    const [organizationSort, setOrganizationSort] = useState({
        name: 'name',
        direction: null 
    });

    const updateOrganizationSort = (sortOrder) => {
        setOrganizationSort(sortOrder);
    };

    return (
        <SortContext.Provider value={{ organizationSort, updateOrganizationSort }}>
            {children}
        </SortContext.Provider>
    );
};

export const useSortContext = () => {
    const context = useContext(SortContext);
    if (!context) {
        throw new Error('useSortContext must be used within a SortProvider');
    }
    return context;
}; 